import { AuthState, Error, UserState } from '@/types'

// TODO: Refactor to use typescript enum
export type AuthCommitToken = AuthState & {
  type: 'token'
}
export type AuthCommitErrorStatus = Error & {
  type: 'errorStatus'
}
export type AuthCommitWaitingStatus = {
  type: 'waitingStatus',
  isWaiting: boolean
}

export type UserCommitInfomation = UserState & {
  type: 'infomation'
}

export enum AppStatusMutationType {
  error = 'error'
}

export enum PatientMutationType {
  update = 'update',
  updateFromId = 'updateFromId'
}

export enum DeviceMutationType {
  update = 'update',
  isBusy = 'isBusy'
}
